// removed by extract-text-webpack-plugin
module.exports = {"movieGrid":"MovieGrid__movieGrid__27dCA","title":"MovieGrid__title__B4PSt","group":"MovieGrid__group__OIHdy","infoMessage":"MovieGrid__infoMessage__w5RUK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MovieGrid/MovieGrid.scss
// module id = 451
// module chunks = 0